import beversImg from '../img/speltakteken_bevers.png';
import welpenImg from '../img/speltakteken_welpen.png';
import scoutsImg from '../img/Speltakteken_scouts.png';
import vrijbuitersImg from '../img/speltakteken_vrijbuiters.png';
import explorersImg from '../img/speltakteken_explorers.png';

export function getSpeltakImage(naam) {
  if (!naam) return null;
  const key = String(naam).toLowerCase();

  if (key === 'bevers') return beversImg;
  if (key === 'welpen') return welpenImg;
  if (key === 'vrijbuiters') return vrijbuitersImg;
  if (key === 'verkenners' || key === 'gidsen') return scoutsImg;
  if (key === 'explorers') return explorersImg;

  return null;
}
